import { AfterContentChecked, Component, DoCheck, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit,DoCheck,AfterContentChecked{
  title = 'project-demo';
  ngOnInit(): void {
    localStorage.setItem("closeWindow","")
    
  }
  ngDoCheck(): void {

   
      
  }
  ngAfterContentChecked(): void {
      if(localStorage.getItem("closeWindow")=="close"){
        window.close()
      }
  }
}
